import { VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { BatchTicketAssetsProvider } from '../../contexts';
import { useProductsSection } from '../../hooks';
import { DynamicAssetWrapper } from '../DynamicAsset';
import { DesktopWrapper, MobileWrapper } from '../SectionWrapper';
import { SectionHeaderWrapper } from '../SectionWrapper/header';
import { SectionLocked } from '../SectionWrapper/locked';

interface ProductProps {}

export const Product: React.FC<ProductProps> = () => {
  const Wrapper = useBreakpointValue({
    base: MobileWrapper,
    sm: DesktopWrapper,
  });

  const isMobile = useBreakpointValue({ base: true, sm: false });

  const {
    handleAddProducts,
    handleEditProducts,
    itemCount,
    onPressBasketButton,
    sectionTitle,
    statusIsComplete,
    statusIsStart,
    statusIsClosed,
  } = useProductsSection();

  if (statusIsClosed) {
    return <SectionLocked title="Selecione o produto" />;
  }

  return (
    <BatchTicketAssetsProvider>
      <Wrapper>
        <VStack
          w="full"
          bg={{ base: 'transparent', sm: 'neutral.white' }}
          borderTopRadius={BoxRadius.sm}
          space={{ base: Spacing['inline.xxs'] }}>
          {!isMobile && (
            <SectionHeaderWrapper
              itemCount={itemCount}
              onAdd={handleAddProducts}
              onEdit={handleEditProducts}
              onPressBasketButton={onPressBasketButton}
              statusIsComplete={statusIsComplete}
              statusIsStart={statusIsStart}
              title={sectionTitle}
            />
          )}
          <Box px={{ base: 0, sm: Spacing['inline.xxs'] }}>
            <DynamicAssetWrapper />
          </Box>
        </VStack>
      </Wrapper>
    </BatchTicketAssetsProvider>
  );
};
